import { get } from 'lodash';
import { createSelector } from 'reselect';
import { getEntities, selectCountry } from '../../global-selectors';

import { selectSubscriberConfig } from './bootstrap';
import { selectCurrentCustomerPaymentProfileId, selectCurrentPaymentMethod } from './payment';

const castPaymentMethodsToArray = (paymentMethods) => Object
  .entries(paymentMethods)
  .map(([key, value]) => ({
    shortCode: key,
    ...value
  }));

export const recaptchaKeySelector = createSelector(
  getEntities,
  entities => entities.bootstrap.config.captchaSecretKey
);

export const selectHasPaymentMethods = createSelector(
  selectSubscriberConfig,
  subscriberConfig => {
    const paymentMethods = (subscriberConfig && subscriberConfig.paymentMethods) && castPaymentMethodsToArray(subscriberConfig.paymentMethods);

    return (Array.isArray(paymentMethods) && paymentMethods.length > 0) && paymentMethods.some((paymentMethod) => {
      if (paymentMethod.shortCode === 'authorizenet') {
        const paymentProfiles = get(paymentMethod, 'paymentProfiles', []);
        return paymentProfiles.length > 0;
      }

      return Boolean(paymentMethod && paymentMethod.shortCode);
    });
  }
);

export const selectSubscriberPaymentMethods = createSelector(
  selectSubscriberConfig,
  subscriberConfig => (subscriberConfig && subscriberConfig.paymentMethods) && castPaymentMethodsToArray(subscriberConfig.paymentMethods)
);

export const selectCurrentPaymentProfile = createSelector(
  selectSubscriberPaymentMethods,
  selectCurrentPaymentMethod,
  selectCurrentCustomerPaymentProfileId,
  (subscriberPaymentMethods, currentPaymentMethod, currentPaymentProfileId) => subscriberPaymentMethods.reduce((acc, paymentMethod) => {
    if (paymentMethod.shortCode === currentPaymentMethod.toLowerCase()) {
      return paymentMethod.paymentProfiles.find((paymentProfile) => paymentProfile.customerPaymentProfileId === currentPaymentProfileId);
    }

    return acc;
  }, null)
);

export const selectCountryCode = createSelector(
  getEntities,
  selectCountry,
  (entities, urlCountry) =>
    get(entities, 'subscriber.country_code') ||
    get(entities, 'user.country') ||
    urlCountry
);
